import { protectedContentApiClient, publicContentApiClient } from '../api-fetcher/api-client';
import {
  CreateInterfaceSettingsMutation,
  GetInterfaceSettingsQuery,
  UpdateInterfaceSettingsMutation
} from '../../graphql/API';
import { graphqlClient, TGraphQLSubscriptions } from '../graphql-api-client/graphql-api-client';
import * as queries from '../../graphql/queries';
import { GraphQLResult } from '@aws-amplify/api';
import * as mutations from '../../graphql/mutations';
import { IInterfaceSetting } from '../../store/podium-info-store/podium-info-store';
import * as subscriptions from '../../graphql/subscriptions';

export interface IPresentationInfo {
  presentationName: string;
  interfaceBrandingLogoUrl: string;
}

export interface IPreviewInfo {
  id: number;
  idHash: string;
  presentationLink: string;
}

type TSubscription<T> = (
  presentationId: string | null,
  doneCallback: (data: T) => void,
  retrySubscriptionFn: () => TGraphQLSubscriptions
) => TGraphQLSubscriptions;

interface IOnUpdateInterfaceSetting {
  onUpdateInterfaceSettings: IInterfaceSetting;
}

export const getPresenterInfoApi = async (hashId: string): Promise<IPresentationInfo> => {
  return publicContentApiClient.get<IPresentationInfo>(`presenter/presentation/${hashId}`);
};

export const getPreviewInfo = async (presentationId: string): Promise<IPreviewInfo> => {
  return await protectedContentApiClient.get<IPreviewInfo>(`presentations/${presentationId}/presenter/preview`);
};

export const getPresenterReviewModeApi = async (presentationId: string): Promise<GraphQLResult<GetInterfaceSettingsQuery>> => {
  return graphqlClient.operation<GetInterfaceSettingsQuery>({
    query: queries.getInterfaceSettings,
    variables: {
      presentationId: presentationId
    }
  });
};

export const createPresenterReviewModeApi = async (body: IInterfaceSetting): Promise<void> => {
  await graphqlClient.operation<CreateInterfaceSettingsMutation>({
    query: mutations.createInterfaceSettings,
    variables: {
      input: { ...body }
    }
  });
};

export const updateReviewModeApi = async (body: IInterfaceSetting): Promise<void> => {
  await graphqlClient.operation<UpdateInterfaceSettingsMutation>({
    query: mutations.updateInterfaceSettings,
    variables: {
      input: { ...body }
    }
  });
};

export const onUpdatePresenterReviewModeSubscriptionApi: TSubscription<IOnUpdateInterfaceSetting> = (
  presentationId,
  doneCallback,
  retrySubscriptionFn
): TGraphQLSubscriptions => {
  return graphqlClient.subscriptions({
    query: subscriptions.onUpdateInterfaceSettings,
    variables: {
      presentationId: presentationId,
    }
  }, doneCallback, retrySubscriptionFn);
};
